import { Link, useLocation } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** Map route segments to human-readable labels */
const SEGMENT_LABELS: Record<string, string> = {
  "": "Home",
  identities: "Identities",
  workloads: "Machine Identities",
  sessions: "Sessions",
  recordings: "Session Recordings",
  verdikta: "Verdikta Engine",
  operations: "Operations",
  aws: "AWS Monitoring",
  policies: "Policies",
  simulate: "Policy Simulation",
  "privileged-access": "Privileged Access",
  reports: "Reports",
  "pilot-success": "Pilot Success",
  "access-reviews": "Access Reviews",
  alerts: "Alerts",
  playbooks: "Playbooks",
  incidents: "Incidents",
  "threat-intel": "Threat Intelligence",
  "impossible-travel": "Impossible Travel",
  "identity-providers": "Identity Providers",
  "protected-applications": "Protected Applications",
  integrations: "Integrations",
  webhooks: "Webhooks",
  siem: "SIEM",
  sinks: "Sinks",
  mfa: "MFA",
  challenges: "Challenges",
  dsr: "Data Subject Requests",
  settings: "Settings",
  config: "Configuration",
  audit: "Audit Log",
  onboarding: "Onboarding",
  checklist: "Connectors",
  connectors: "Connectors",
  dev: "Developer",
  "my-sessions": "My Sessions",
  "remote-access": "Remote Access",
  "endpoint-agents": "Endpoint Agents",
};

export function Breadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  if (segments.length === 0) return null;

  const crumbs = segments.map((segment, index) => {
    const path = "/" + segments.slice(0, index + 1).join("/");
    const label = SEGMENT_LABELS[segment] || segment.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
    const isLast = index === segments.length - 1;
    return { path, label, isLast };
  });

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
      {crumbs.map((crumb, i) => (
        <span key={crumb.path} className="flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3 w-3 text-subtle" />}
          {crumb.isLast ? (
            <span className="text-subtle font-medium">
              {crumb.label}
            </span>
          ) : (
            <Link
              to={crumb.path}
              className="text-accent-primary hover:text-accent-primary-hover font-medium transition-colors"
            >
              {crumb.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
